import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageArticles,
  PageArticle,
  PageArticlePreview,
} from '../pages/articles';

const RouteArticles = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageArticles />
      </Route>
      <Route path={`${path}/:_id/preview`}>
        <PageArticlePreview />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageArticle />
      </Route>
    </Switch>
  );
};

export default RouteArticles;
